// @ts-nocheck baseline 2026-02-16
import LegacyKitModule, { presentLegacyApp } from "modules/legacy-kit";
import { secureStorage, SecureStorageKeys } from "@src/services/secure-storage";
import { getUseLegacyAuth } from "@src/config/useLegacyAuth";
import { useAuthStore } from "../auth-store";

export async function syncLegacyKitCredentials(): Promise<boolean> {
  if (!getUseLegacyAuth()) {
    return false;
  }

  if (typeof LegacyKitModule.setCredentials !== "function") {
    return false;
  }

  const { legacyAuth, user } = useAuthStore.getState();
  let legacyToken = legacyAuth?.token;
  let legacyUserId = legacyAuth?.userId;
  let legacyUserEmail = legacyAuth?.userEmail ?? user?.email ?? undefined;

  if (!legacyToken || !legacyUserId) {
    const [storedToken, storedUserId, storedEmail] = await Promise.all([
      secureStorage.get(SecureStorageKeys.legacyAuthToken),
      secureStorage.get(SecureStorageKeys.legacyUserId),
      secureStorage.get(SecureStorageKeys.legacyUserEmail),
    ]);

    legacyToken ??= storedToken ?? undefined;
    legacyUserId ??= storedUserId ?? undefined;
    legacyUserEmail ??= storedEmail ?? undefined;
  }

  if (!legacyToken || !legacyUserId) {
    return false;
  }

  LegacyKitModule.setCredentials(legacyUserId, legacyToken, legacyUserEmail);
  return true;
}

export async function presentLegacyAppWithCredentials(): Promise<void> {
  await syncLegacyKitCredentials();
  await presentLegacyApp();
}
